var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('NewsEditor',{attrs:{"news":_vm.theNews(_vm.newsId)},on:{"submitted":_vm.updateNews}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }